import { makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    "& .highlight-form": {
      maxWidth: "100%",
      minWidth: "100%",
    },
  },
  sectionTitle: {
    fontSize: theme.typography.pxToRem(30),
    color: "#0F172A",
    fontFamily: "Inter",
    fontWeight: 600,
    margin: "5px 0",
  },
  mentorTipDetails: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 700,
    "& span": {
      fontWeight: "bold",
    },
  },
}));
